export class MemberNewLoginSessionRequest {
    MemberID: number;
    Note: string;
}
